<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">Create Workflow Batch</h3>
</div>
<div class="modal-body dx-form dx-add-batch-form">
  <div *ngIf="!ready" class="row" style="margin-bottom: 20px;">
        <div class="col-sm-12 alert-danger text-center">{{LOCALIZATION.workflowUnavailable}}</div>
  </div>    
    
  <div *ngIf="workflows && workflows.length > 0" class="form-inline">
    <div class="col-sm-3"><span>Select a workflow</span></div>
    <div class="col-sm-9">
		<select class="form-control"
		        name="workflowSelect"
		        [(ngModel)]="input.selectedWorkflow"
		        (change)="loadSelectedWorkflow()">
			<option *ngFor="let w of workflows" [ngValue]="w">
			  {{ w.config.label }}
			</option>
		</select>
    </div>
  </div>
  <div *ngIf="!workflows || workflows.length == 0">{{LOCALIZATION.workflowNoneConfigured}}</div>   
   
 <div *ngIf="batch.workflow" class="row">
	<div class="col-xs-12 form-inline">
	     <div class="col-xs-3 ">
	         <span [attr.aria-label]="LOCALIZATION.batchDetails">{{LOCALIZATION.batchDetails}}</span>
	     </div>
	     <div class="col-xs-9 well-sm">
	     	<span class="dx-batch-description">{{batch.workflow.config?.description || ''}}</span>
            
			<button class="btn" type="button" 
			  [ngClass]="{'btn-primary': !isSelectedRecordsInvalidFormat, 'btn-warning': isSelectedRecordsInvalidFormat, 'btn-danger': selectedRecords.length==0}"
			  data-toggle="collapse" data-target="#collapseExample"
			  aria-expanded="false" aria-controls="collapseExample">
	            <span class="list-header">{{LOCALIZATION.batchContents}}:
	            <!-- 
	                <ng-pluralize count="selectedRecords.length" when="{'0': 'no documents', 
	                                 '1': '1 document',
	                                 'other': '{{selectedRecords.length}} documents'}">
	                </ng-pluralize>
	             --> 
	             <span>{{ selectedRecords.length | i18nPlural: pluralMapping }}</span>   
	            </span>
			</button>
			<div class="alert-warning" *ngIf="isSelectedRecordsInvalidFormat">Some document formats are not supported. Click to edit the batch contents.</div>
			<div class="alert-danger" *ngIf="selectedRecords.length==0">The batch must include at least one document.</div>
			<div class="collapse" id="collapseExample">
			  <div class="well" style="max-height:350px; overflow:scroll;">
				<ul class="list-group" style="padding-bottom: 8px">
				 <li class="list-group-item" [ngClass]="{'background-red text-white': !r.dxvalid}" *ngFor="let r of selectedRecords">
                    <label class="control control--checkbox">
                      <input [(ngModel)]="r.ignore" type="checkbox"/>
                      <div class="control__indicator"></div>
                    </label>
				 	<span [attr.title]="r.uidescription">{{ r.title }}</span>
				 </li>
				</ul>
				<button class="btn btn-primary" type="button" [hidden]="selectedRecords.length==0" (click)="remove()">{{LOCALIZATION.remove}}</button>			    
			  </div>
			</div>            
	     </div>
	</div>  	
 	
	<div class="col-xs-12 form-inline">
	     <div class="col-xs-3">
	         <span [attr.aria-label]="LOCALIZATION.batchName"><span class="required">*</span> {{LOCALIZATION.batchName}}</span>
	     </div>
	     <div class="col-xs-9">
	         <input type="text" 
	         	class="item-input" 
	         	[(ngModel)]="batch.name" 
	         	required 
	         	placeholder="{{LOCALIZATION.batchName}}" 
	         	aria-label="Batch name value">
	     </div>
	</div> 
	<div class="col-xs-12 form-inline">
	     <div class="col-xs-3">
	         <span [attr.aria-label]="LOCALIZATION.dueDate">{{LOCALIZATION.dueDate}}</span>
	     </div>     
	     <div class="col-xs-4">
	         <input type="date" 
	         	min="{{minDueDate}}" 
	         	class="item-input" 
	         	[(ngModel)]="batch.dueDate" 
	         	placeholder="{{LOCALIZATION.dueDate}}" 
	         	aria-label="Due date value">
	     </div>
	     <div class="col-xs-1">
	         <span [attr.aria-label]="LOCALIZATION.priority">{{LOCALIZATION.priority}}</span>
	     </div>
         <div class="col-xs-3">
             <select type="text" class="form-control" [(ngModel)]="batch.priority" style="margin-bottom:10px;width:85%" aria-label="Priority value">
                 <option *ngFor="let priority of priorities" [ngValue]="priority">{{ priority }}</option>
             </select>
         </div>	     
	</div>
	<div class="col-xs-12 form-inline">
	     <div class="col-xs-3 ">
	         <span [attr.aria-label]="LOCALIZATION.comments">{{LOCALIZATION.comments}}</span>
	     </div>
	     <div class="col-xs-9">
	         <input type="text" 
	         	class="item-input" 
	         	[(ngModel)]="batch.comments" 
	         	placeholder="Field Value" 
	         	aria-label="Comments value">
	     </div>
	</div> 	
		
    <!-- --------------------------Dynamic workflow parameters -------------------------- -->	
	<div class="col-xs-12" *ngFor="let parameter of batch.workflow?.parameters" style="padding-top: 4px;">
	     <div class="col-xs-3 form-inline">
	         <span [attr.aria-label]="parameter.displayName"><span class="required">{{parameter.required ? "*" : ""}}</span> {{parameter.displayName}}</span>
	     </div>
	     <div class="col-xs-9 form-inline">
		     <div [ngSwitch]="parameter.type">
			     <div *ngSwitchCase="'PARTICIPANT'">
					 <label style="display:inline-block;" class="control control--checkbox"> 
					    <span class="dx-small-label">{{LOCALIZATION.assignRole}}</span>
					    <input type="checkbox"
					    	[attr.aria-label]="LOCALIZATION.assignRoleDescription" 
					    	[(ngModel)]="parameter.values.is_jbpm_usertask_group_assignment" />
					 	<div class="control__indicator"></div>
					 </label>
					 <div>
						 <span class="dx-form dx-small-label">{{LOCALIZATION.assignGroup}}</span>			     	 
				         <select class="form-control" style="margin-bottom:10px;display:inline-block;width:auto;" 
				         		 [attr.aria-label]="'field ' + parameter.displayName + ' value'"
				         	     [disabled]="parameter.values.is_jbpm_usertask_group_assignment || parameter.values.awdx_user_id"
				         		 [(ngModel)]="parameter.values.awdx_group_id">
				             <option *ngFor="let group_participant of parameter.values.group_participants" [ngValue]="group_participant">{{ group_participant }}</option>
				         </select>	
			         </div>
			         <div>
						 <span class="dx-form dx-small-label">{{LOCALIZATION.assignUser}}</span>			     	 
				         <select class="form-control" style="margin-bottom:10px;display:inline-block;width:auto;" 
				         		 [attr.aria-label]="'field ' + parameter.displayName + ' value'"
				         	     [disabled]="parameter.values.is_jbpm_usertask_group_assignment || parameter.values.awdx_group_id"
				         		 [(ngModel)]="parameter.values.awdx_user_id">
				             <option *ngFor="let participant of parameter.values.participants" [ngValue]="participant.username">{{ participant.displayName }}</option>
				         </select>
			         </div>
			     </div>
			     <div *ngSwitchCase="'STRING'">
				     <input type="text" class="item-input" 
				     		[(ngModel)]="parameter.value" 
				     		[required]="parameter.required"
				         	placeholder="Field Value" 
				         	[attr.aria-label]="'field ' + parameter.displayName + ' value'">
			     </div>
			     <div *ngSwitchCase="'BOOLEAN'">
					<div class="toggle-switch" style="padding-top: 4px;">
						<input id="{{parameter.name}}"
							class="toggle-switch-toggle toggle-switch-toggle-round" 
							type="checkbox" 
							[(ngModel)]="parameter.value" 
							[attr.aria-label]="'field ' + parameter.displayName + ' value'">
						<label for="{{parameter.name}}"></label>
					</div>
			     </div>			     
			     <div *ngSwitchCase="'DATE'">
				     <input type="date" 
						     class="item-input" 
						     [(ngModel)]="parameter.value" 
						     [required]="parameter.required"
				         	 placeholder="Field Value" 
				         	 [attr.aria-label]="'field ' + parameter.displayName + ' value'">
			     </div>
			     <div *ngSwitchCase="'LIST'">
			         <select class="form-control" 
			         		 style="margin-bottom:10px;display:inline-block;width:auto;" 
			         	     [attr.aria-label]="'field ' + parameter.displayName + ' value'"
			         	     [required]="parameter.required"
			         		 [(ngModel)]="parameter.value">
			            <!-- <option ng-repeat="(val,display) in parameter.values track by $index" value="{{val}}">{{display}}</option>  -->
					    <option *ngFor="let entry of parameter.values; let i = index" [value]="entry.key">
					      {{ entry.value }}
					    </option>
			         </select>				         	
			     </div>
			     <div *ngSwitchCase="'QUERY'" class="dx-query-grid">
					<label *ngIf="isOCRSearchEnabled" style="display:inline;" class="control control--checkbox"> 
					    <span class="dx-small-label" title="Automatically modify the search settings based on the OCR quality of the document">{{LOCALIZATION.ocrTuneSearch}}</span>
					    <input aria-label="Use OCR-based fuzzy search" type="checkbox" [(ngModel)]="parameter.values.ocr_tuned_search" />
					 	<div class="control__indicator"></div>
					</label>		
					
					<!-- Each grid is displayed in its own tab -->
					<ul ngbNav #nav="ngbNav" class="nav nav-tabs">
					  <li ngbNavItem class="nav-item">
					    <a class="nav-link" ngbNavLink>
					      {{ LOCALIZATION.queryLists }}
					    </a>					    
					    <ng-template ngbNavContent>
							<!-- Grid displaying selectable workflow query lists -->
							<workflow-querylist-selector></workflow-querylist-selector>	    
					    </ng-template>
					  </li>
					  <li ngbNavItem class="nav-item">
					    <a class="nav-link" ngbNavLink>
					      {{ LOCALIZATION.queries }}
					    </a>
					    <ng-template ngbNavContent>
						   	<!-- Grid displaying selectable workflow queries -->
							<workflow-query-selector></workflow-query-selector>
					    </ng-template>
					  </li>
					  <li ngbNavItem class="nav-item" [hidden]="!isNEREnabled">
					    <a class="nav-link" ngbNavLink>
					      {{ LOCALIZATION.entityExtraction }}
					    </a>					    
					    <ng-template ngbNavContent>
							<!-- Grid displaying selectable workflow NER queries -->
							<workflow-ner-selector></workflow-ner-selector>	    
					    </ng-template>
					  </li>
					</ul>
					<div [ngbNavOutlet]="nav" class="tab-content"></div>					
						         	
			     </div>		     
		     </div>
	     </div>
	</div>
	
 </div>  
</div>
<div class="modal-footer">
	<div class="pull-left">
	    <span class="required">*</span><span class="" style="font-style:italic;"> - {{LOCALIZATION.requiredFields}}</span>
	</div>
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button *ngIf="workflows && workflows.length > 0" class="btn btn-primary" type="button" (click)="onSave()" [disabled]="inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.submit}}
    </button>
</div>
